module.exports = __webpack_public_path__ + "static/Nanopesos4-7f9577e088d4c94a11365f54927f1107.png";